import { useState } from 'react'
import { Checkbox, InputBase, Popover, TextInput } from '@mantine/core'
import { IconChevronDown, IconSearch } from '@tabler/icons-react'

export default function TableFilterMultiSelect({ filter, value, onChange }) {
    const [opened, setOpened] = useState(false)
    const [search, setSearch] = useState('')
    const options = filter.options ?? []
    const selected = value.map(String)
    const labels = selected.map((key) => options.find((option) => String(option.value) === key)?.label ?? key)
    const normalize = (text) => String(text).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('fr')
    const matches = options.filter((option) => normalize(option.label).includes(normalize(search.trim())))
    const summary = selected.length > 1 ? `${selected.length} sélectionnés` : labels[0] ?? 'Choisir…'

    return <Popover opened={opened} onChange={setOpened} position="bottom-start" width="target" withinPortal={false} shadow="md" radius="md" returnFocus>
        <Popover.Target>
            <InputBase component="button" type="button" label={filter.name} pointer
                rightSection={<IconChevronDown size={16} />} rightSectionPointerEvents="none"
                onClick={() => { setSearch(''); setOpened((current) => !current) }}
                onKeyDown={(event) => { if (event.key === 'Escape') setOpened(false) }}
                title={labels.join(', ') || undefined} styles={{ root: { width: '100%', minWidth: 0, maxWidth: '100%' }, wrapper: { minWidth: 0, maxWidth: '100%' }, input: { textAlign: 'left', width: '100%', minWidth: 0, maxWidth: '100%', overflow: 'hidden' } }}>
                <span className={`block w-full min-w-0 truncate ${selected.length ? '' : 'text-gray-500'}`}>
                    {summary}
                </span>
            </InputBase>
        </Popover.Target>
        <Popover.Dropdown p={6} style={{ maxWidth: 'calc(100vw - 32px)' }}>
            {options.length > 7 && <TextInput aria-label={`Rechercher dans ${filter.name}`} placeholder="Rechercher…" leftSection={<IconSearch size={14} />}
                value={search} onChange={(event) => setSearch(event.currentTarget.value)} mb={6} />}
            <div className="max-h-60 overflow-y-auto overscroll-contain" role="group" aria-label={filter.name}>
                {matches.map((option) => <Checkbox key={option.value} label={option.label} disabled={option.disabled}
                    checked={selected.includes(String(option.value))}
                    onChange={(event) => onChange(event.currentTarget.checked
                        ? [...selected, String(option.value)] : selected.filter((key) => key !== String(option.value)))}
                    className="rounded-md hover:bg-gray-50"
                    styles={{ body: { alignItems: 'center', padding: '9px 10px' }, labelWrapper: { flex: 1, minWidth: 0 }, label: { cursor: 'pointer', lineHeight: 1.4, overflowWrap: 'anywhere' } }} />)}
                {!matches.length && <p className="px-3 py-2 text-sm text-gray-500">Aucun résultat.</p>}
            </div>
        </Popover.Dropdown>
    </Popover>
}
